const collectionsGetters = {
  getBannerTitle(collection) {
    return collection[0]?.banner_title ?? null;
  },
  getBannerSubtitle(collection) {
    return collection[0]?.banner_subtitle ?? null;
  },
  getDesktopBannerImage(collection) {
    return collection[0]?.banner_image_desktop_url ?? null;
  },
  getMobileBannerImage(collection) {
    return collection[0]?.banner_image_mobile_url ?? null;
  },
  getCollections(collection) {
    return collection[0]?.collections?.items ?? [];
  },
  getCollectionDesktopImage(collection) {
    return collection?.thumbnail_desktop_url ?? null;
  },
  getCollectionMobileImage(collection) {
    return collection?.thumbnail_mobile_url ?? null;
  },
  getCollectionTitle(collection) {
    return collection?.title ?? '';
  },
  getCollectionDescription(collection) {
    return collection?.description ?? '';
  },
  getCollectionUrl(collection) {
    return collection?.url_path
      ? `/${collection?.url_path}`
      : '';
  },
};

export default collectionsGetters;
